import './formcheckbox.less'

import {DOMAttrs, m} from '@codeurs/front'
import {ErrorMessage, Field} from 'formik'
import {FunctionComponent} from 'react'
import {Mod} from 'types'
import {style} from 'util/style'

const styles = style('formcheckbox')

export const FormCheckbox: FunctionComponent<
	{
		name: string
		value: string
		label: string
		btnlayout?: boolean
	} & DOMAttrs
> = ({name, value, label, btnlayout = false, ...attrs}) => {
	if (!name || !value || !label) return

	return (
		<div class={styles}>
			<label class={styles('container')}>
				<Field
					type="checkbox"
					name={name}
					value={value}
					class={styles('input')}
					{...attrs}
				/>
				{!btnlayout && <span class={styles('check')} />}
				<span class={styles('label')}>{label}</span>
			</label>
			<ErrorMessage name={name}>
				{msg => <div class={styles('error')}>{msg}</div>}
			</ErrorMessage>
		</div>
	)
}
